import { useFormContext } from 'react-hook-form';
import { FIELD_LABEL_CLASS } from '@/components/common/FormDialog/formDialog.constants';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { CreateSurveyFormValues } from '../../types/survey.types';
import { NumberField } from './primitives/NumberField';

const RANGE_FIELDS = [
  { key: 'minValue', label: 'Min value' },
  { key: 'maxValue', label: 'Max value' },
] as const;

interface QuestionRangeFieldsProps {
  questionIndex: number;
}

export function QuestionRangeFields({ questionIndex }: QuestionRangeFieldsProps) {
  const { control } = useFormContext<CreateSurveyFormValues>();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {RANGE_FIELDS.map((rangeField) => (
        <FormField
          key={rangeField.key}
          control={control}
          name={`questions.${questionIndex}.${rangeField.key}`}
          render={({ field, fieldState }) => (
            <FormItem>
              <FormLabel className={FIELD_LABEL_CLASS}>{rangeField.label}</FormLabel>
              <FormControl>
                <NumberField
                  value={field.value}
                  onChange={field.onChange}
                  aria-invalid={fieldState.invalid || undefined}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  );
}
